// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__bNfEH","heading":"Partners_heading__bf2uN","content":"Partners_content__zvJHo","images":"Partners_images__Bqo6U"};